/**
 * Tiny, no-auth localStorage tracker for "what circles/topics has this visitor
 * engaged with?". Used by TrendingCirclesStrip to pin a "Made for you" card.
 *
 * Stores at most 8 entries, newest first, deduplicated, case-insensitive.
 */
const KEY = "vmeetio:recent_interests:v1";
const MAX = 8;

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch (_e) {
    return [];
  }
}

function write(arr) {
  try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); }
  catch (_e) { /* private mode / quota */ }
}

/** Push one or many circle/tag strings to the front of the recent list. */
export function recordInterests(...interests) {
  const flat = interests.flat().map((s) => (s || "").trim()).filter(Boolean);
  if (!flat.length) return;
  const lc = (s) => s.toLowerCase();
  const existing = read();
  const seen = new Set();
  const merged = [];
  [...flat, ...existing].forEach((s) => {
    const k = lc(s);
    if (!seen.has(k)) { seen.add(k); merged.push(s); }
  });
  write(merged);
}

/** Returns the most-recent interest list (lowercased) for matching. */
export function getRecentInterestsLC() {
  return read().map((s) => s.toLowerCase());
}

/** Returns true when the visitor has at least one recorded interest. */
export function hasInterestSignal() {
  return read().length > 0;
}
